import CustomStyleSheet from '@prahatech/util-react-web/stylesheet/CustomStyleSheet';

export function PaymentErrorScreen() {
  document.title = 'docpay - Payment Failure';

  return (
    <div className='payment-error-screen'>
      <h1>An error has occurred during your payment.</h1>

      <p>Please retry the payment by opening the private link sent to you via email.</p>
    </div>
  );
}

const scope = '.payment-error-screen';
const styles = `
  {
    flexbox: column center center;
    width: 100%;
    height: 100%;
    padding: 15px;
  }

  h1 {
    color: conf(color, warn);
    margin: 0;
    font-preset: 3em light;
    text-align: center;
    padding-bottom: conf(spacing, smallest);
  }

  p {
    color: conf(color, darkerGrey);
    font-preset: 1.2em light;
    text-align: center;
    margin: 0;
  }
`;

CustomStyleSheet.create(styles, scope);
